// El fichero env.sh se ejecuta durante el arranque de la aplicación. El primer paso es mapear las varaibles definididas en el application manifest en el fichero .env.
// Luego para que el navegador pueda leer las variables necesita un fichero de tipo .js por lo añade las variables al fichero env.js de la raíz del proyecto.
// El env.js, está en la raíz y es generado por el env.sh a partir de lo que recupera .env en el arranque y se usa en el index.html como <script sex="env.js"><script> para que el navegador pueda usar esas variables del manifest.
// El src/env.js es importante tenerlo para poder arrancar la aplicación en local ya que Angular necesita cargar información del src/env.js ya que no tiene acceso a la raíz en local.
// Al final del proceso, el navegador ya puede leer los valores definidos en environment.

declare global {
    interface Window { config: any; }
}

// tslint:disable: no-string-literal
export const environment = {
    production: false,
    appBaseHref: '/ui/app',
    apiBaseUrl: window.location.origin + '/bff',
    ibackend_url: window.location.origin + '/bff',
    olimpo_env: globalThis.config?.olimpo_env || 'LOCAL',
    // okta_env: globalThis.config?.okta_env || 'NOPROD_DEVINT',
    // context:'/genesysinformes/bff', // Ejemplo por si se quiere habilitar context
    analytics: {
        id: 'UA-163823957-1'
    },
    defaultLanguage: {
        code: 'es',
        name: 'EspaÃ±ol'
    },
    languagesList: [
        {
            code: 'en',
            name: 'English',
        },
        {
            code: 'es',
            name: 'Español',
        },
        {
            code: 'fr',
            name: 'Français',
        },
        {
            code: 'de',
            name: 'Deutsch',
        },
        {
            code: 'it',
            name: 'Italiano',
        },
        {
            code: 'pl',
            name: 'Polski',
        },
    ],
    debug: true,
    // okta config
    okta_config: {
        issuer: globalThis.config?.okta_issuer || 'https://integrator-6194250.okta.com/oauth2/aus10wfh3vpnYsYHD698', // Modificar por el Okta de aplicación de DEV
        baseUrl: globalThis.config?.okta_baseUrl || 'https://integrator-6194250.okta.com/', // Modificar por el Okta de aplicación de DEV
        clientId: globalThis.config?.okta_clientId || '0oa11cjrxt33qnssl698', // Modificar por el Okta de aplicación de DEV
        redirectUri: `${window.location.origin}/ui/app/implicit/callback`, // Modificar por el Okta de aplicación de DEV
        features: {
            registration: true,
            rememberMe: true,
        },
        authParams: {
            issuer: globalThis.config?.okta_issuer || 'https://integrator-6194250.okta.com/oauth2/aus10wfh3vpnYsYHD698', // Modificar por el Okta de aplicación de DEV
            responseType: ['token', 'id_token'],
            display: 'page'
        },
        scopes: ['openid', 'profile', 'email', 'offline_access'],
        pkce: true

    }

};
